import permissions from '../../permissions'

const PAYMENT_CONTRACT_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.PAYMENT_CONTRACTS.MANAGE,
    description:
      'Permite o gerenciamento completo de contratos, ordens de pagamento e ' +
      'serviços vinculados. O usuário com esta permissão pode criar e editar ' +
      'contratos, acompanhar e gerenciar o fluxo de ordens de pagamento e ' +
      'cadastrar ou alterar os serviços associados a cada contrato.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.PAYMENT_CONTRACTS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.SHOW,
    tag: permissions.PAYMENT_CONTRACTS.SHOW,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.INVOICE,
    tag: permissions.PAYMENT_CONTRACTS.INVOICE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.PAYMENT_CONTRACTS.DESTROY,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY + ' serviço',
    tag: permissions.PAYMENT_CONTRACTS.DESTROY_SERVICE,
  },
]

export default PAYMENT_CONTRACT_LIST
